export const SLUMP_MAX_US = 15;
/**
 * spacing code for N/A
 */
export const NA_SPACING_CODE = '0';

/**
 * Default text for empty value
 */
export const DEFAULT_EMPTY_VALUE_DOUBLE_DASH = '--';
